
import API from '../../api/api';
import * as actionTypes from '../actionTypes';
import {message} from 'antd';

function getListaComuniDocumentoIdentificativo(provincia,apiPath) {
  return (dispatch) => {
    API.getAxios(apiPath).get(`/anagrafica/provincia/${provincia}/comuni`)
      .then(response => { 
        dispatch({ type: actionTypes.LISTA_COMUNI_DOCUMENTO_IDENTIFICATIVO, payload: response.data});
        dispatch({ type: actionTypes.LOADING_COMUNI_FALSE});
      })
      .catch(errore => { 
        //dispatch({ type: actionTypes.LISTA_COMUNI_DOCUMENTO_IDENTIFICATIVO, payload: errore.response.data});
        message.error(`Errore ${errore.response.data.errorCode}: ${errore.response.data.errorMessage}`,15);
        dispatch({ type: actionTypes.LOADING_COMUNI_FALSE});
    })
  };
}

export default getListaComuniDocumentoIdentificativo;
